import url from '../url'
import headers from '../headers'

export default {
	add (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/invitations/`,
			model,
			headers.bearer()
		)
	},
	getAll (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/invitations/`,
			headers.bearer()
		)
	},
	getAllAccept (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/invitations/accept/`,
			headers.bearer()
		)
	},
	getAllPendent (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/invitations/pendent/`,
			headers.bearer()
		)
	},
	getAllReceived (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/invitations/received/`,
			headers.bearer()
		)
	},
	resend (context, user_uid, id) {
		return context.$http.put(
			`${url}/users/${user_uid}/invitations/${id}/resend/`,
			{},
			headers.bearer()
		)
	},
	accept (context, user_uid, id) {
		return context.$http.put(
			`${url}/users/${user_uid}/invitations/${id}/accept/`,
			{},
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/invitations.js